module.exports = __webpack_public_path__ + "static/media/hotel5.c44ed6ac.jpg";